import axiosInstance from './http';

function logAndRethrow(endpoint, error) {
    if (error?.response) {
        console.error(`[responsiblesApi] ${endpoint} -> ${error.response.status}`, {
            url: error.response.config?.url,
            method: error.response.config?.method,
            params: error.response.config?.params,
            data: error.response.data,
            headers: error.response.headers,
        });
    } else {
        console.error(`[responsiblesApi] ${endpoint} -> network/error`, error);
    }
    throw error;
}

export const RESPONSIBLE_ENTITY = {
    customer: 'customer',
    contract: 'contract',
    facility: 'facility',
    work: 'work',
};

export default {
    async getCurrent(entityType, id) {
        try {
            const { data } = await axiosInstance.get(`responsibles/${entityType}/${id}/current`);
            return data; // { items, primary_user_id, cache_ids? }
        } catch (error) {
            logAndRethrow(`GET responsibles/${entityType}/${id}/current`, error);
        }
    },

    async assign(entityType, id, { user_id, priority, make_primary, comment } = {}) {
        try {
            const { data } = await axiosInstance.post(`responsibles/${entityType}/${id}/assign`, {
                user_id, priority, make_primary, comment,
            });
            return data; // ResponsibilityItem
        } catch (error) {
            logAndRethrow(`POST responsibles/${entityType}/${id}/assign`, error);
        }
    },

    async unassign(entityType, id, { user_id, priority, reason } = {}) {
        try {
            const { data } = await axiosInstance.post(`responsibles/${entityType}/${id}/unassign`, {
                user_id, priority, reason,
            });
            return data; // { ok: true }
        } catch (error) {
            logAndRethrow(`POST responsibles/${entityType}/${id}/unassign`, error);
        }
    },

    async makePrimary(entityType, id, { user_id, priority } = {}) {
        try {
            const { data } = await axiosInstance.post(`responsibles/${entityType}/${id}/make-primary`, {
                user_id, priority,
            });
            return data; // ResponsibilityItem
        } catch (error) {
            logAndRethrow(`POST responsibles/${entityType}/${id}/make-primary`, error);
        }
    },

    async reorder(entityType, id, { orders } = {}) {
        try {
            const { data } = await axiosInstance.post(`responsibles/${entityType}/${id}/reorder`, {
                orders,
            });
            return data; // { ok: true }
        } catch (error) {
            logAndRethrow(`POST responsibles/${entityType}/${id}/reorder`, error);
        }
    },

    async getHistory(entityType, id, { page } = {}) {
        try {
            const { data } = await axiosInstance.get(`responsibles/${entityType}/${id}/history`, { params: { page } });
            return data; // PaginatedResponsibilityHistoryList
        } catch (error) {
            logAndRethrow(`GET responsibles/${entityType}/${id}/history`, error);
        }
    },
};